import { useDataChange, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let task = useDataValue({
    context: 'task',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.bulk_task_ids = [task.id]
      next.bulk_tasks = [task]
    })

    setFlowTo(
      normalizePath(props.viewPath, '../../../../../../MoveModal/Content')
    )
  }
}
